import { PaymentForm } from '@/app/components/ppra/components/ppra-payment-page/PPRAPaymentPage';
import { ROUTE_PAYMENT_COLLECT_PAYMENT_METHOD } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';

export const routePaymentCollectPaymentMethod: RouteObject = {
  path: ROUTE_PAYMENT_COLLECT_PAYMENT_METHOD,
  Component: PaymentForm,
  loader: setTitleFromLoader('Payment'),
};
